import { createRef, useEffect } from 'react'
import useCheckDetailsViewModel from '../CheckDetailsViewModel'
import cn from 'clsx'

import CircleSpinner from '@components/shared/CircleSpinner'
import CheckDetailsSummary from './CheckDetailsSummary'
import CheckDetailsWellsTable from './CheckDetailsWellsTable'
import LabelStudioEditor from '@components/shared/LabelStudioEditor'
import { FaFileExport, FaFileDownload, FaFileUpload } from 'react-icons/fa'
import { MdKeyboardArrowLeft } from 'react-icons/md'

import './CheckDetails.css'
import CheckDetailsProduction from './CheckDetailsProduction'
import Pagination from '@/components/shared/Pagination'
import { UploadFile } from '@/components/shared/UploadFile'

// September 27th, 2023
// Don't delete yet - we may still have annotators use this
// more basic editing UI, since relationships in LS are complicated right now
const USE_BASIC_CHECK_EDITOR = false

const CheckDetails = () => {
    
    const {
        
        refEditor,
        navigate,
        
        error,
        loading,
        pageCount,
        isExporting,
        isDownloading,
        isUploading,
        isEditMode,
        
        check,
        checkWells,
        checkRevenue,
        checkProduction,
        
        labelStudioError,
        
        toggleEditMode,
        fetchCheckWells,
        fetchCheckRevenue,
        fetchCheckProduction,
        onExportCheckClick,
        onDownloadCheckClick,
        onUploadCheckClick,
        setPageIndex,
        
    } = useCheckDetailsViewModel(true)
    
    const uploadRef = createRef()
    
    useEffect(() => {
        
        if (check?.id) {
            fetchCheckWells(check.id)
            fetchCheckRevenue(check.id)
            fetchCheckProduction(check.id)
        }
        
    }, [check])
    
    if (error) return (
        <div className="w-full Check">
            <p>Failed to load check</p>
        </div>
    )
    
    if (loading || !check) return (
        <div className="w-full CheckDetails">
            <CircleSpinner className="absolute-centered" />
        </div>
    )
    
    if (!loading && !check?.pages?.length) return (
        <div className="w-full CheckDetails">
            <p>No pages found for check</p>
        </div>
    )
    
    return (
        
        <div className={cn('CheckDetails', {
            'edit-mode': isEditMode,
        })}>
            <UploadFile
                accept={{ 'application/pdf': [] }}
                fieldName="file"
                onDrop={onUploadCheckClick}
                multiple={false}
                ref={uploadRef}
                hidden={true} />
            <header>
                
                <div className="flex items-center content-center">
                    <button
                        className="mr-2 btn btn-link flex items-center content-center"
                        onClick={navigate.toChecks}>
                        <MdKeyboardArrowLeft />
                        <span className="ml-2">Back</span>
                    </button>
                    <h3>{check.name}</h3>
                </div>
                
                {isEditMode && <Pagination
                    count={pageCount}
                    setPageIndex={setPageIndex} />}
                
                <div className="flex items-center content-center justify-end gap-2">
                    {/* <Link
                        className="btn btn-primary"
                        to={`/checks/${check.id}/edit`}>
                        Edit Check
                    </Link> */}
                    <button
                        className="btn btn-primary"
                        type="button"
                        disabled={!check.fileExists || !check?.pages?.length}
                        onClick={USE_BASIC_CHECK_EDITOR
                            ? () => navigate.toCheckDetail(check?.id)
                            : toggleEditMode
                        }>
                        {isEditMode ? 'Close Editor' : 'Edit Check'}
                    </button>
                    <button
                        className="flex items-center content-center btn btn-success"
                        disabled={isExporting}
                        onClick={onExportCheckClick}>
                        <FaFileExport />
                        <span className="ml-2">
                            {isExporting ? 'Exporting...' : 'Export'}
                        </span>
                    </button>
                    {check.fileExists && <button
                        className="flex items-center content-center btn btn-secondary"
                        onClick={onDownloadCheckClick}>
                        <FaFileDownload />
                        <span className="ml-2">
                            {isDownloading ? 'Downloading...' : 'Download'}
                        </span>
                    </button>}
                    {!check.fileExists && <button
                        className="flex items-center content-center btn btn-secondary"
                        onClick={() => uploadRef.current?.open()}>
                        <FaFileUpload />
                        <span className="ml-2">
                            {isUploading ? 'Uploading...' : 'Upload'}
                        </span>
                    </button>}
                
                </div>
            </header>
            
            {isEditMode && (
                <LabelStudioEditor
                    ref={refEditor}
                    className="mt-3"
                    error={labelStudioError} />
            )}
            
            {!isEditMode && (<>
                
                <CheckDetailsSummary check={check} checkRevenue={checkRevenue} />
                
                <h4 className="mt-4 text-xl">Production</h4>
                <CheckDetailsProduction checkProduction={checkProduction} />
                
                <h4 className="mt-4 text-xl">Other</h4>
                <CheckDetailsWellsTable wells={checkWells} />
            
            </>)}
            
            {/* <div>
                <pre>
                    <code className="text-white">
                        {JSON.stringify(checkWells, null, 4)}
                    </code>
                </pre>
            </div> */}
        
        </div>
        
    )
    
}

export default CheckDetails
